import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Redirect } from 'react-router-dom';
import styles from './styles';
import {
    withStyles,
    Card,
    CardContent,
    TextField,
    Typography,
    CardActions
} from '@material-ui/core';
import LoadingButton from '../../../LoadingButton';
import SafeLogo from '../../../../assets/images/sselogo1(nobackwhite).png';
import { verifyForgotPasswordToken, createNewPassword } from '../../../../actions/authentication';
import { openSnackBar } from '../../../../actions/snack-bar';
class CreatePassword extends Component {
    state = {
        newPassword: '',
        confirmPassword: '',
        isVerified: true
    }
    componentDidMount () {
        const { match: { params }, history, dispatch } = this.props;
        if (!params.token) history.push('/organization/register');
        else {
            dispatch(verifyForgotPasswordToken(params.token))
            .then(() => this.setState({ isVerified: true }))
            .catch(error => {
                dispatch(openSnackBar({ message: error.response.body.message || 'Invalid token ' }))
                this.setState({ isVerified: false })
            })
        }
    }

    validatAndSubmit = event => {
        event.preventDefault();
        const { newPassword, confirmPassword } = this.state;
        const { match: { params }, history, dispatch } = this.props;
        if (!newPassword) {
            dispatch(
                openSnackBar({
                  message: 'Please enter new password'
                })
            )
            return;
        } else if (!confirmPassword) {
            dispatch(
                openSnackBar({
                  message: 'Please enter confirm password'
                })
            )
            return;
        } else if (newPassword !== confirmPassword) {
            dispatch(
                openSnackBar({
                  message: 'Confirm password did not match'
                })
            )
            return;
        }

        const data = { new_password: newPassword };
        dispatch(createNewPassword(data, params.token))
        .then(() => {
            dispatch(
                openSnackBar({
                  message: 'Password changed successfully.'
                })
            );
            history.push('/organization/register');
        })
        .catch(() => dispatch(openSnackBar({ message: 'Invalid token ' })));
    }

    render() {
        const { classes } = this.props;
        const { isVerified, newPassword, confirmPassword } = this.state;
        if (!isVerified) return <Redirect to={"/organization/register"} />
        return (
            <div className={classes.app}>
                <span className={classes.header}>
                    <img src={SafeLogo} alt="Safe" className={classes.safeLogo} />
                </span>
                <Card className={classes.cardWrapper}>
                    <div className={classes.formGroup}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <form onSubmit={this.validatAndSubmit}>
                                <Typography variant="h6" component="h6" className={classes.loginheading} >
                                    Create password
                                </Typography>
                                <CardContent className={this.props.classes.cardContentRoot}>
                                    <TextField
                                    name="newPassword"
                                    id="newPassword"
                                    label="New Password"
                                    type="password"
                                    className={classes.textField}
                                    margin="normal"
                                    value={newPassword}
                                    onChange={event => this.setState({ newPassword: event.target.value })}
                                    />

                                    <TextField
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    label="Confirm new Password"
                                    className={classes.textField}
                                    type="password"
                                    autoComplete="nope"
                                    margin="normal"
                                    value={confirmPassword}
                                    onChange={event => this.setState({ confirmPassword: event.target.value })}
                                    />
                                </CardContent>
                                <CardActions className={classes.wrapper}>
                                    <LoadingButton
                                        variant="contained"
                                        // working
                                        disabled={false}
                                        className={classes.largeButton}
                                        type="submit"
                                    >
                                        SUBMIT
                                    </LoadingButton>
                              </CardActions>
                            </form>
                        </div>
                    </div>
                </Card>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        authentication: state.authentication
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles, { withTheme: true })
)(CreatePassword)
